// Mock data for Triton Global Trade with Brand Structure - Updated with Real Products

export const productCategories = [
  {
    id: 1,
    name: "Spices & Masala",
    description: "Premium quality spice blends and masalas",
    image: "https://images.pexels.com/photos/31280796/pexels-photo-31280796.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    brands: [
      {
        id: 1,
        name: "Nature's Choice",
        products: [
          { name: "Amchur Powder", sizes: ["180 pkts x 100gm"] },
          { name: "Kasuri Methi (Fenugreek Leaves)", sizes: ["120 pkts x 25gm", "48 pkts x 100gm", "6 pkts x 1kg"] },
          { name: "Hyd. Biryani Pulao Masala", sizes: ["240 pkts x 50gm"] },
          { name: "Chilli Powder (Deggi)", sizes: ["180 pkts x 100gm", "24 pkts x 500gm"] },
          { name: "Chilli Powder (Kashmiri)", sizes: ["180 pkts x 100gm"] },
          { name: "Chicken Curry Masala", sizes: ["180 pkts x 100gm", "24 pkts x 500gm"] },
          { name: "Meat Curry Masala", sizes: ["180 pkts x 100gm", "24 pkts x 500gm"] },
          { name: "Pav Bhaji Masala", sizes: ["180 pkts x 100gm"] },
          { name: "Pani Puri Masala", sizes: ["180 pkts x 100gm"] },
          { name: "Garam Masala", sizes: ["180 pkts x 100gm", "24 pkts x 500gm"] },
          { name: "Shahi Paneer Masala", sizes: ["180 pkts x 100gm"] },
          { name: "Dal Makhani Masala", sizes: ["180 pkts x 100gm"] },
          { name: "Kitchen King Masala", sizes: ["180 pkts x 100gm", "24 pkts x 500gm"] },
          { name: "Turmeric Powder", sizes: ["120 pkts x 100gm"] },
          { name: "Coriander Powder", sizes: ["120 pkts x 100gm"] }
        ]
      },
      {
        id: 2,
        name: "MDH",
        products: [
          { name: "Garam Masala", sizes: ["100g", "200g", "500g"] },
          { name: "Chana Masala", sizes: ["100g", "500g"] },
          { name: "Chicken Masala", sizes: ["100g", "500g"] },
          { name: "Pav Bhaji Masala", sizes: ["100g", "500g"] },
          { name: "Kitchen King", sizes: ["100g", "500g"] }
        ]
      },
      {
        id: 3,
        name: "Everest",
        products: [
          { name: "Garam Masala", sizes: ["50g", "100g", "200g"] },
          { name: "Turmeric Powder", sizes: ["100g", "200g", "500g"] },
          { name: "Red Chilli Powder", sizes: ["100g", "200g", "500g"] },
          { name: "Biryani Masala", sizes: ["50g", "100g"] }
        ]
      }
    ]
  },
  {
    id: 2,
    name: "Snacks",
    description: "Delicious ready-to-eat Indian snacks",
    image: "https://images.unsplash.com/photo-1599490659213-e2b9527bd087?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzbmFja3N8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 4,
        name: "Haldiram",
        products: [
          { name: "Aloo Kulcha", sizes: ["400g x 12 pkts (4.8kg C/S)"] },
          { name: "Alu Shev (Bhujia)", sizes: ["150g x 80 pkts", "350g x 40 pkts"] },
          { name: "Bhelpuri", sizes: ["150g x 60 pkts", "300g x 20 pkts"] },
          { name: "Mini Samosa", sizes: ["200g x 40 pkts"] },
          { name: "Mini Bhakarwadi", sizes: ["200g x 40 pkts"] },
          { name: "All In One Mix", sizes: ["150g x 80 pkts", "350g x 40 pkts"] },
          { name: "Moong Dal", sizes: ["150g x 80 pkts"] },
          { name: "Chatpata Dal", sizes: ["150g x 80 pkts"] },
          { name: "Soya Sticks", sizes: ["150g x 60 pkts"] }
        ]
      }
    ]
  },
  {
    id: 3,
    name: "Sweets & Desserts",
    description: "Traditional Indian sweets and desserts",
    image: "https://images.unsplash.com/photo-1643022592081-cf1f52bbc6bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw1fHxpbmRpYW4lMjBzd2VldHN8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 5,
        name: "Haldiram",
        products: [
          { name: "Kaju Rolls", sizes: ["20 pkts x 250gms"] },
          { name: "Son Rolls", sizes: ["20 pkts x 250gms"] },
          { name: "Kesar Badam Halwa", sizes: ["30 pkts x 250gms"] },
          { name: "Mix Nut Chikki", sizes: ["72 pkts x 4 x 25gms"] },
          { name: "Cashewnut Chikki", sizes: ["72 pkts x 4 x 25gms"] },
          { name: "Soan Papdi (Assorted)", sizes: ["60 box x 250gms"] },
          { name: "Rossogulla (Tins)", sizes: ["20 tins x 1kg", "40 tins x 500gms"] },
          { name: "Gulabjamun (Tins)", sizes: ["20 tins x 1kg", "40 tins x 500gms"] },
          { name: "Rasmalai (Easy Open)", sizes: ["20 tins x 1kg", "40 tins x 500gms"] },
          { name: "Rajbhog (Easy Open)", sizes: ["20 tins x 1kg", "40 tins x 500gms"] }
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Sauces & Condiments",
    description: "Flavorful sauces, syrups and condiments",
    image: "https://images.unsplash.com/photo-1472476443507-c7a5948772fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw4fHxzYXVjZXMlMjBib3R0bGVzfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 6,
        name: "Maggi",
        products: [
          { name: "Hot & Sweet Sauce", sizes: ["12 btls x 1kg", "24 btls x 500g"] },
          { name: "Tomato Ketchup", sizes: ["12 btls x 1kg", "24 btls x 500g"] }
        ]
      },
      {
        id: 7,
        name: "Hamdard",
        products: [
          { name: "Rooh Afza", sizes: ["12 btls x 700ml"] }
        ]
      },
      {
        id: 8,
        name: "Kalvert's",
        products: [
          { name: "Rose Syrup", sizes: ["12 btls x 700ml"] }
        ]
      },
      {
        id: 9,
        name: "Mother's Recipe",
        products: [
          { name: "Mixed Pickle", sizes: ["12 btls x 500gms"] },
          { name: "Chilli Pickle", sizes: ["12 btls x 500gms"] }
        ]
      }
    ]
  },
  {
    id: 5,
    name: "Food Colours & Essences",
    description: "Premium food colors and essences",
    image: "https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw2fHxmb29kJTIwY29sb3JpbmclMjBib3R0bGVzfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 10,
        name: "Bush",
        products: [
          { name: "Orange Red Food Colour", sizes: ["120 tins x 100g"] },
          { name: "Lemon Yellow Food Colour", sizes: ["120 tins x 100g"] },
          { name: "Apple Green Food Colour", sizes: ["60 tins x 100g"] }
        ]
      },
      {
        id: 11,
        name: "Viola",
        products: [
          { name: "Rose Essence", sizes: ["40 box x 10 btls x 20ml"] },
          { name: "Vanilla Essence", sizes: ["40 box x 10 btls x 20ml"] }
        ]
      }
    ]
  },
  {
    id: 6,
    name: "Baking & Dessert Mixes",
    description: "Premium baking ingredients and dessert mixes",
    image: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw5fHxiYWtpbmclMjBpbmdyZWRpZW50c3xlbnwwfHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 12,
        name: "BlueBird",
        products: [
          { name: "Custard Powder", sizes: ["25 pkts x 500gms", "100 pkts x 100gms"] }
        ]
      }
    ]
  },
  {
    id: 7,
    name: "Dairy & Ghee",
    description: "Pure ghee and dairy products",
    image: "https://images.unsplash.com/photo-1628088062854-d1870b4553da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw3fHxnaGVlfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 13,
        name: "Amul",
        products: [
          { name: "Pure Ghee", sizes: ["12 tins x 1ltr", "6 tins x 2ltr"] }
        ]
      }
    ]
  },
  {
    id: 8,
    name: "Pooja & Religious Items",
    description: "Traditional items for religious ceremonies",
    image: "https://images.unsplash.com/photo-1604608672516-f767bb8228d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw1fHxpbmNlbnNlJTIwc3RpY2tzfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 14,
        name: "Premium",
        products: [
          { name: "Pooja Samagri (Plastic Box)", sizes: ["50 box x 200gms"] },
          { name: "Rose Water", sizes: ["36 btls x 600ml", "72 btls x 200ml"] },
          { name: "Kewra Water", sizes: ["36 btls x 600ml", "72 btls x 200ml"] }
        ]
      },
      {
        id: 15,
        name: "Cycle",
        products: [
          { name: "Pure Agarbatti", sizes: ["100 sticks", "200 sticks"] },
          { name: "Dhoop Sticks", sizes: ["50 sticks"] }
        ]
      }
    ]
  },
  {
    id: 9,
    name: "Dry Fruits & Nuts",
    description: "Premium quality dry fruits and nuts",
    image: "https://images.unsplash.com/photo-1599599810769-bcde5a160d32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw4fHxkcnklMjBmcnVpdHN8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 16,
        name: "Premium Select",
        products: [
          { name: "Mixed Dry Fruits", sizes: ["1 pkt x 400g"] }
        ]
      }
    ]
  },
  {
    id: 10,
    name: "Biscuits & Cookies",
    description: "Delicious biscuits and cookies from trusted brands",
    image: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxiaXNjdWl0c3xlbnwwfHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 17,
        name: "Karara",
        products: [
          { name: "Maska Khari (Butter)", sizes: ["400g x 20 pkts"] },
          { name: "Masala Khari (Mixed Spices)", sizes: ["400g x 20 pkts"] },
          { name: "Methi Khari (Fenugreek)", sizes: ["400g x 20 pkts"] },
          { name: "Jeera Khari (Cumin)", sizes: ["400g x 20 pkts"] },
          { name: "Munch Bites Schezwan", sizes: ["150g x 40 pkts"] },
          { name: "Munch Bites Mexican", sizes: ["150g x 40 pkts"] },
          { name: "Munch Bites Cheese Garlic", sizes: ["150g x 40 pkts"] },
          { name: "Munch Bites Tomato", sizes: ["150g x 40 pkts"] },
          { name: "Baked Kothambir Vadi", sizes: ["200g x 24 pkts"] },
          { name: "Baked Kachori", sizes: ["200g x 48 pkts"] },
          { name: "Roasted Surti Mix", sizes: ["200g x 40 pkts"] },
          { name: "Kolhapuri Bhadang Bhel", sizes: ["200g x 40 pkts"] },
          { name: "Roasted Jawari Mix", sizes: ["200g x 40 pkts"] },
          { name: "Roasted Gehu Poha", sizes: ["200g x 40 pkts"] },
          { name: "Roasted Chivda", sizes: ["200g x 40 pkts"] },
          { name: "Roasted Rosty Toasty", sizes: ["200g x 40 pkts", "150g x 40 pkts"] },
          { name: "Roasted Multigrain", sizes: ["200g x 40 pkts", "150g x 40 pkts"] },
          { name: "Roasted Masala Gehu", sizes: ["150g x 40 pkts"] }
        ]
      },
      {
        id: 18,
        name: "Britannia",
        products: [
          { name: "50/50 Biscuits", sizes: ["84 pkts x 80g", "48 pkts x 150g", "36 pkts x 250g"] },
          { name: "Marie Gold Biscuits", sizes: ["84 pkts x 80g", "48 pkts x 150g", "36 pkts x 250g"] },
          { name: "Tiger Biscuits", sizes: ["84 pkts x 80g", "48 pkts x 150g"] },
          { name: "Good Day Biscuits", sizes: ["84 pkts x 80g", "48 pkts x 150g", "36 pkts x 250g"] },
          { name: "Bourbon Biscuits", sizes: ["84 pkts x 80g", "48 pkts x 150g", "36 pkts x 250g"] }
        ]
      },
      {
        id: 19,
        name: "Parle",
        products: [
          { name: "Parle G Biscuits", sizes: ["14 pkts x 800g", "72 pkts x 120g"] },
          { name: "Hide & Seek Biscuits", sizes: ["48 pkts x 150g", "36 pkts x 250g"] },
          { name: "Krack-jack Biscuits", sizes: ["72 pkts x 120g"] },
          { name: "Monaco Biscuits", sizes: ["72 pkts x 120g", "48 pkts x 150g"] }
        ]
      }
    ]
  },
  {
    id: 11,
    name: "Confectionery",
    description: "Sweet treats, candies and jams",
    image: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw3fHxjYW5kaWVzfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 20,
        name: "Dabur",
        products: [
          { name: "Amla Candy", sizes: ["12 pcs x 500g", "24 pcs x 250g", "24 jar x 500g"] },
          { name: "Anardana Pachak", sizes: ["50 btls x 100g"] },
          { name: "Hajmola Candy 100s", sizes: ["12 pcs x 481g"] },
          { name: "Hajmola Reg Bottle", sizes: ["72 btls x 120 tab"] },
          { name: "Hajmola Tab", sizes: ["72 btls x 120 tab"] },
          { name: "Chyawanprash Regular", sizes: ["12 jar x 1kg", "24 jar x 500g"] },
          { name: "Chyawanprash Mango", sizes: ["12 jar x 1kg", "24 jar x 500g"] },
          { name: "Chyawanprash Sugar Free", sizes: ["12 jar x 1kg", "24 jar x 500g"] }
        ]
      },
      {
        id: 21,
        name: "Kissan",
        products: [
          { name: "Fruit Jam", sizes: ["24 btls x 500g"] },
          { name: "Mango Jam", sizes: ["24 btls x 500g"] },
          { name: "Mixed Fruit Jam", sizes: ["24 btls x 500g"] }
        ]
      },
      {
        id: 22,
        name: "Pulse",
        products: [
          { name: "Pulse Candy Guava", sizes: ["16 jar x 520g"] },
          { name: "Pulse Candy Kachcha Aam", sizes: ["16 jar x 540g"] }
        ]
      },
      {
        id: 41,
        name: "Perfetti",
        products: [
          { name: "Centre Fresh", sizes: ["16 jar x 646.400g"] }
        ]
      },
      {
        id: 42,
        name: "Charlie",
        products: [
          { name: "Charlie Peanut Laddu", sizes: ["80 pkts x 200g"] }
        ]
      },
      {
        id: 43,
        name: "Divya",
        products: [
          { name: "Green Mango Candy", sizes: ["24 pkts x 200g"] },
          { name: "Hajmola Candy", sizes: ["24 pkts x 200g"] },
          { name: "Santra Candy", sizes: ["24 pkts x 200g"] }
        ]
      }
    ]
  },
  {
    id: 12,
    name: "Beverages",
    description: "Refreshing soft drinks and beverages",
    image: "https://images.unsplash.com/photo-1437418747212-8d9709afab22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw5fHxzb2Z0JTIwZHJpbmtzfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 23,
        name: "PepsiCo",
        products: [
          { name: "7 UP Nimbooz", sizes: ["24 btls x 350ml"] }
        ]
      },
      {
        id: 24,
        name: "Parle Agro",
        products: [
          { name: "Frooti", sizes: ["24 btls x 600ml"] }
        ]
      },
      {
        id: 25,
        name: "Coca-Cola",
        products: [
          { name: "Limca Cans", sizes: ["24 tins x 300ml"] },
          { name: "Thums Up Cans", sizes: ["24 tins x 300ml"] },
          { name: "Maaza Mango Juice", sizes: ["12 btls x 1.25ltr"] }
        ]
      }
    ]
  },
  {
    id: 13,
    name: "Patanjali Products",
    description: "Ayurvedic and natural products from Patanjali",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxMHx8YXl1cnZlZGljJTIwcHJvZHVjdHN8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 26,
        name: "Patanjali",
        products: [
          { name: "Patanjali Ghee", sizes: ["15 tetra x 1ltr", "30 tetra x 500ml"] },
          { name: "Patanjali Honey", sizes: ["40 pcs x 250g", "25 pcs x 100g"] },
          { name: "Patanjali Dant Kanti Toothpaste", sizes: ["72 pcs x 200g", "48 pcs x 100g"] },
          { name: "Patanjali Atta Noodles", sizes: ["128 pkts x 60g", "24 pkts x 240g"] },
          { name: "Patanjali Kesh Kanti Hair Oil", sizes: ["24 pcs x 120ml", "48 pcs x 120ml"] },
          { name: "Patanjali Coconut Hair Oil", sizes: ["36 pcs x 200ml", "36 jar x 200ml"] },
          { name: "Patanjali Soap Ojas Aquya", sizes: ["72 pcs x 75g", "48 pcs x 75g"] },
          { name: "Patanjali Soap Mogra", sizes: ["72 pcs x 75g", "48 pcs x 75g"] },
          { name: "Patanjali Soap Tulsi", sizes: ["72 pcs x 75g", "48 pcs x 75g"] }
        ]
      }
    ]
  },
  {
    id: 14,
    name: "Hair Care & Beauty",
    description: "Hair oils and beauty products",
    image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxMHx8aGFpciUyMG9pbHxlbnwwfHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 27,
        name: "Bajaj",
        products: [
          { name: "Bajaj Almond Hair Oil", sizes: ["16 btls x 300ml"] }
        ]
      },
      {
        id: 28,
        name: "Dabur",
        products: [
          { name: "Dabur Amla Hair Oil", sizes: ["24 btls x 275ml", "36 btls x 180ml"] }
        ]
      },
      {
        id: 29,
        name: "Parachute",
        products: [
          { name: "Parachute Coconut Oil", sizes: ["100 btls x 175ml", "40 btls x 500ml"] }
        ]
      },
      {
        id: 30,
        name: "Mehandi",
        products: [
          { name: "Mehandi Oil", sizes: ["40 doz x 50mls"] }
        ]
      },
      {
        id: 44,
        name: "Vatika",
        products: [
          { name: "Vatika Shampoo Regular", sizes: ["48 btls x 100mls", "24 btls x 200ml", "12 btls x 500ml"] },
          { name: "Vatika Shampoo Anti Dandruff", sizes: ["48 btls x 100mls", "24 btls x 200ml", "12 btls x 500ml"] }
        ]
      }
    ]
  },
  {
    id: 15,
    name: "Ayurvedic & Wellness",
    description: "Ayurvedic medicines and wellness products",
    image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw4fHxheXVydmVkaWN8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 31,
        name: "Eno",
        products: [
          { name: "Eno Fruit Salt", sizes: ["48 btls x 100gm"] }
        ]
      },
      {
        id: 32,
        name: "Hamdard",
        products: [
          { name: "Hamdard Safi", sizes: ["40 btls x 200mls", "12 btls x 500mls"] }
        ]
      },
      {
        id: 33,
        name: "Zandu",
        products: [
          { name: "Zandu Pain Balm", sizes: ["400 btls x 10gms"] }
        ]
      },
      {
        id: 45,
        name: "Vicks",
        products: [
          { name: "Vicks Vaporub", sizes: ["16 x 20 x 25gm"] }
        ]
      },
      {
        id: 46,
        name: "Woodward's",
        products: [
          { name: "Woodward's Gripe Water", sizes: ["90 btls x 130ml"] }
        ]
      }
    ]
  },
  {
    id: 16,
    name: "Personal Care & Cosmetics",
    description: "Complete range of personal care and cosmetic products",
    image: "https://images.unsplash.com/photo-1600857544200-242c90e255b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw3fHxzb2Fwc3xlbnwwfHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 34,
        name: "Lifebuoy",
        products: [
          { name: "Lifebuoy Soap", sizes: ["108 pcs x 125gm", "144 pcs x 100gm"] }
        ]
      },
      {
        id: 35,
        name: "Lux",
        products: [
          { name: "Lux Soap", sizes: ["108 pcs x 125gm", "144 pcs x 100gm"] }
        ]
      },
      {
        id: 36,
        name: "Hamam",
        products: [
          { name: "Hamam Soap", sizes: ["108 pcs x 125gm", "144 pcs x 100gm"] }
        ]
      },
      {
        id: 37,
        name: "Mysore Sandal",
        products: [
          { name: "Mysore Sandal Soap", sizes: ["200 pcs x 75gm", "120 pcs x 125gm"] }
        ]
      },
      {
        id: 47,
        name: "Pond's",
        products: [
          { name: "Pond's Talc Pink", sizes: ["25 pcs x 400gm"] },
          { name: "Pond's Talc Lavender", sizes: ["25 pcs x 400gm"] }
        ]
      },
      {
        id: 49,
        name: "Yardley",
        products: [
          { name: "Yardley Talc Assorted", sizes: ["48 pcs x 250g"] }
        ]
      },
      {
        id: 48,
        name: "Close-Up",
        products: [
          { name: "Close-Up Toothpaste", sizes: ["144 pkts x 80gms"] }
        ]
      },
      {
        id: 50,
        name: "Colgate",
        products: [
          { name: "Colgate Toothpaste", sizes: ["72 pcs x 200g", "48 pcs x 100g"] }
        ]
      },
      {
        id: 51,
        name: "Pepsodent",
        products: [
          { name: "Pepsodent Toothpaste", sizes: ["48 pcs x 150g"] }
        ]
      },
      {
        id: 52,
        name: "Vicco",
        products: [
          { name: "Vicco Vajradanti Toothpaste", sizes: ["40 pcs x 200g"] }
        ]
      },
      {
        id: 53,
        name: "Glow & Lovely",
        products: [
          { name: "Glow & Lovely Cream", sizes: ["48 pcs x 80g", "72 pcs x 50g"] }
        ]
      },
      {
        id: 54,
        name: "Gillette",
        products: [
          { name: "Gillette Shaving Cream", sizes: ["24 pcs x 100g"] },
          { name: "Gillette Shaving Foam", sizes: ["12 pcs x 418g"] }
        ]
      },
      {
        id: 55,
        name: "Boroplus",
        products: [
          { name: "Boroplus Antiseptic Cream", sizes: ["48 pcs x 80ml", "72 pcs x 40ml"] }
        ]
      }
    ]
  },
  {
    id: 17,
    name: "Utensils & Kitchenware",
    description: "Quality cookware and kitchen utensils",
    image: "https://images.unsplash.com/photo-1556911073-38141963c9e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw3fHxraXRjaGVuJTIwdXRlbnNpbHN8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 38,
        name: "Premium Kitchenware",
        products: [
          { name: "Aluminum Topes + Lid (3pcs Set)", sizes: ["1 set"] },
          { name: "Aluminum Topes + Lid (5pcs Set)", sizes: ["1 set"] },
          { name: "Aluminum Topes + Lid (7pcs Set)", sizes: ["1 set"] },
          { name: "Aluminum Topes + Lid (9pcs Set)", sizes: ["1 set"] },
          { name: "S.S. Tiffin 2 Tier", sizes: ["50 pieces"] },
          { name: "S.S. Tiffin 3 Tier", sizes: ["40 pieces"] },
          { name: "S.S. Tiffin 4 Tier", sizes: ["20 pieces"] },
          { name: "S.S. Masala Dabba No.10", sizes: ["50 pieces"] },
          { name: "S.S. Masala Dabba No.11", sizes: ["50 pieces"] },
          { name: "S.S. Masala Dabba No.12", sizes: ["50 pieces"] },
          { name: "S.S. Masala Dabba No.13", sizes: ["50 pieces"] },
          { name: "S.S. Serving Spoon No.1", sizes: ["36 pcs x 80g"] },
          { name: "S.S. Serving Spoon No.2", sizes: ["36 pcs x 100g"] },
          { name: "S.S. Serving Spoon No.3", sizes: ["36 pcs x 100g"] },
          { name: "S.S. Serving Spoon No.4", sizes: ["36 pcs x 100g"] },
          { name: "S.S. Serving Spoon No.5", sizes: ["36 pcs x 100g"] },
          { name: "S.S. Dinner Plate No.10", sizes: ["50 pieces"] },
          { name: "S.S. Dinner Plate No.11", sizes: ["50 pieces"] },
          { name: "S.S. Dinner Plate No.12", sizes: ["50 pieces"] },
          { name: "S.S. Dinner Plate No.13", sizes: ["50 pieces"] },
          { name: "S.S. Dinner Plate No.14", sizes: ["50 pieces"] },
          { name: "Copper Hawan Kund", sizes: ["25 pieces"] },
          { name: "Aluminum Hawan Kund", sizes: ["25 pieces"] },
          { name: "Iron Kadai", sizes: ["25 pcs"] },
          { name: "Iron Tawa", sizes: ["25 pcs"] }
        ]
      },
      {
        id: 39,
        name: "Everest",
        products: [
          { name: "Everest Kitchen Press", sizes: ["48 pcs/ctn"] },
          { name: "Everest Chilly Cutter", sizes: ["24 pcs/ctn"] }
        ]
      }
    ]
  },
  {
    id: 18,
    name: "Religious & Festival Items",
    description: "Traditional religious items and festival decorations",
    image: "https://images.unsplash.com/photo-1610701596007-11502861dcfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw4fHxkaXdhbGklMjBkaXlhfGVufDB8fHx8MTc3MTU5MjQzNHww&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 40,
        name: "Cycle",
        products: [
          { name: "Cycle Agarbatti (Incense Sticks)", sizes: ["50 box x 6 x 20 stk", "25 doz x 20 stks"] }
        ]
      },
      {
        id: 56,
        name: "Zed Black",
        products: [
          { name: "Zed Black Agarbatti", sizes: ["50 box x 6 x 20 stk", "25 doz x 20 stks"] }
        ]
      },
      {
        id: 57,
        name: "Mangaldeep",
        products: [
          { name: "Mangaldeep Agarbatti", sizes: ["50 box x 6 x 20 stk", "25 doz x 20 stks"] }
        ]
      },
      {
        id: 58,
        name: "Traditional Items",
        products: [
          { name: "Dhoop Sticks Padmini", sizes: ["10 gross x 10", "80 dozen carton"] },
          { name: "Dhoop Sticks Laxmi", sizes: ["10 gross x 10", "80 dozen carton"] },
          { name: "Camphor Charminar", sizes: ["90 x 16 pkt x 4 tab", "600 box x 20 pkt"] },
          { name: "Camphor Jai Santoshi Maa", sizes: ["90 x 16 pkt x 4 tab", "600 box x 20 pkt"] },
          { name: "Cotton Wicks Long", sizes: ["100 pkts x 50", "200 pkts x 100"] },
          { name: "Cotton Wicks Round", sizes: ["100 pkts x 50", "200 pkts x 100"] },
          { name: "Chandan Tika", sizes: ["50 btls x 50g", "100 btls x 25g"] },
          { name: "Ashtagandha", sizes: ["50 btls x 50g", "100 btls x 25g"] },
          { name: "Diwali Diya Clay", sizes: ["Assorted designs (carton pack)"] },
          { name: "Diwali Diya Brass", sizes: ["Assorted designs (carton pack)"] },
          { name: "Diwali Diya Wax Filled", sizes: ["Assorted designs (carton pack)"] },
          { name: "Ganpati Murti Small", sizes: ["Various sizes"] },
          { name: "Ganpati Murti Medium", sizes: ["Various sizes"] },
          { name: "Ganpati Murti Large", sizes: ["Various sizes"] },
          { name: "Rakhi Hand-made", sizes: ["100 doz/ctn"] },
          { name: "Rakhi Designer", sizes: ["100 doz/ctn"] }
        ]
      }
    ]
  },
  {
    id: 19,
    name: "Household & Cleaning Products",
    description: "Complete range of household cleaning products",
    image: "https://images.unsplash.com/photo-1585421514738-01798e348b17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxMHx8Y2xlYW5pbmclMjBwcm9kdWN0c3xlbnwwfHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    brands: [
      {
        id: 59,
        name: "Harpic",
        products: [
          { name: "Harpic Toilet Cleaner", sizes: ["12 btls x 500ml", "12 btls x 1ltr"] }
        ]
      },
      {
        id: 60,
        name: "Lizol",
        products: [
          { name: "Lizol Surface Cleaner", sizes: ["12 btls x 500ml", "12 btls x 975ml"] }
        ]
      },
      {
        id: 61,
        name: "Vim",
        products: [
          { name: "Vim Bar", sizes: ["72 pcs x 200g", "120 pcs x 100g"] },
          { name: "Vim Liquid", sizes: ["24 btls x 500ml", "48 btls x 250ml"] }
        ]
      },
      {
        id: 62,
        name: "Colin",
        products: [
          { name: "Colin Glass Cleaner", sizes: ["24 btls x 500ml"] }
        ]
      },
      {
        id: 63,
        name: "Dettol",
        products: [
          { name: "Dettol Antiseptic Liquid", sizes: ["24 btls x 500ml", "48 btls x 250ml"] }
        ]
      },
      {
        id: 64,
        name: "Comfort",
        products: [
          { name: "Comfort Fabric Conditioner", sizes: ["12 btls x 860ml", "24 btls x 200ml"] }
        ]
      },
      {
        id: 65,
        name: "Rin",
        products: [
          { name: "Rin Detergent Powder", sizes: ["12 pkts x 1kg", "24 pkts x 500g"] }
        ]
      },
      {
        id: 66,
        name: "Surf Excel",
        products: [
          { name: "Surf Excel Detergent Powder", sizes: ["12 pkts x 1kg", "24 pkts x 500g"] }
        ]
      }
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "Special Packing & Labelling",
    description: "Customized packaging solutions tailored to your market requirements. We provide branded labels, multilingual packaging, and compliance with international standards.",
    image: "https://images.unsplash.com/photo-1644079446600-219068676743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzcxNTkyNDQ4fDA&ixlib=rb-4.1.0&q=85",
    features: ["Custom branding", "Multilingual labels", "Barcode integration", "Tamper-proof packaging"]
  },
  {
    id: 2,
    title: "Assorted Containers",
    description: "Flexible container loading options for mixed product shipments. Optimize your logistics costs with our efficient container consolidation services.",
    image: "https://images.pexels.com/photos/4487382/pexels-photo-4487382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Mixed product containers", "Optimized loading", "Cost-effective shipping", "Full tracking support"]
  },
  {
    id: 3,
    title: "Quality Assurance",
    description: "Rigorous quality checks at every stage to ensure only the finest products reach your shelves. We maintain international quality standards.",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxMHx8cXVhbGl0eSUyMGNvbnRyb2x8ZW58MHx8fHwxNzcxNTkyNDM0fDA&ixlib=rb-4.1.0&q=85",
    features: ["Laboratory testing", "Certification support", "Quality documentation", "Compliance management"]
  },
  {
    id: 4,
    title: "Global Logistics",
    description: "End-to-end logistics support from sourcing to delivery. Our experienced team handles all documentation and customs clearance.",
    image: "https://images.unsplash.com/photo-1678182451047-196f22a4143e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxzaGlwcGluZyUyMGNvbnRhaW5lcnN8ZW58MHx8fHwxNzcxNTkyNDAzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Complete documentation", "Customs clearance", "Freight forwarding", "Door-to-door delivery"]
  }
];

export const companyInfo = {
  name: "Triton Global Trade",
  tagline: "Bridging Markets, Building Trust",
  description: "Triton Global Trade is a leading merchant exporter specializing in premium Indian spices, pulses, FMCG products, and household items. We serve supermarkets and retailers worldwide with a commitment to quality, reliability, and customer satisfaction.",
  mission: "To bridge global markets by delivering authentic Indian products while building lasting relationships based on trust and excellence.",
  values: [
    "Quality Assurance",
    "Timely Delivery",
    "Customer Focus",
    "Ethical Business Practices"
  ],
  whyChooseUs: [
    {
      title: "Extensive Product Range",
      description: "From spices to household items, we offer a comprehensive catalog for all your sourcing needs."
    },
    {
      title: "Quality Certified",
      description: "All our products meet international quality standards and certifications."
    },
    {
      title: "Reliable Supply Chain",
      description: "Consistent supply and timely delivery to keep your shelves stocked."
    },
    {
      title: "Competitive Pricing",
      description: "Direct sourcing and efficient operations ensure the best value for your investment."
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al-Rashid",
    company: "Emirates Supermarket Chain, UAE",
    text: "Triton Global Trade has been our trusted partner for over 3 years. Their product quality and reliability are exceptional.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Johnson",
    company: "Global Foods UK",
    text: "The custom packaging and labeling services have helped us seamlessly integrate their products into our stores.",
    rating: 5
  },
  {
    id: 3,
    name: "Rajesh Patel",
    company: "Spice World, Singapore",
    text: "Outstanding service and authentic products. Triton understands the international market requirements perfectly.",
    rating: 5
  }
];

export const contactInfo = {
  email: "info@tritonglobaltrade.com",
  emailSecondary: "tritonglobaltrade@gmail.com",
  phone: "+91 9819618390",
  address: "C1303, Tulsi Prerna, Sector 1, Khanda Colony, New Panvel 410206, Maharashtra, India",
  website: "www.tritonglobaltrade.com"
};
